export default __webpack_public_path__ + "static/media/vaccinationIcon.507dfc9c.svg";